import React from 'react';

const AuthLogo = () => {
    return (
        <a href="#" className="d-flex align-items-center gap-3 mb-4 text-decoration-none justify-content-center">
            <img src="/images/new-stock-logo.svg" alt="logo" className="stock-logo-img"/>
            <span className="h2 fw-bold mb-0 text-dark stock-logo-text">StockHero</span>
        </a>
    );
};

export default AuthLogo;
